import TabsView from '@/layouts/tabs/TabsView'
import BlankView from '@/layouts/BlankView'
import PageView from '@/layouts/PageView'

// 路由配置
const options = {
	routes: [
		{
			path: '/login',
			name: '登录页',
			component: () => import('@/pages/login')
		},
		{
			path: '/here',
			name: '输入框登录页',
			component: () => import('@/pages/here')
		},
		{
			path: '*',
			name: '404',
			component: () => import('@/pages/exception/404'),
		},
		{
			path: '/403',
			name: '403',
			component: () => import('@/pages/exception/403'),
		},
		{
			path: '/',
			name: '首页',
			component: TabsView,
			redirect: '/login',
			children: [
				{
					path: 'result',
					name: '结果页',
					meta: {
						icon: 'check-circle-o',
					},
					component: PageView,
					children: [
						{
							path: 'success',
							name: '成功',
							component: () => import('@/pages/result/Success')
						},
						{
							path: 'error',
							name: '失败',
							component: () => import('@/pages/result/Error')
						}
					]
				},
				{
					path: 'exception',
					name: '异常页',
					meta: {
						icon: 'warning',
					},
					component: BlankView,
					children: [
						{
							path: '404',
							name: 'Exp404',
							component: () => import('@/pages/exception/404')
						},
						{
							path: '403',
							name: 'Exp403',
							component: () => import('@/pages/exception/403')
						},
						{
							path: '500',
							name: 'Exp500',
							component: () => import('@/pages/exception/500')
						}
					]
				}
			]
		},
	]
}

export default options
